import React from "react";
import logo from "../assets/blockforever-logo.svg";

import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <div className="footer">
      <div className="flex-spaceBtwn">
        <div>
          <div className="flex">
            <img src={logo} alt="Block Foreover logo" className="logo" />
            <span className="primaryColorText bold ml-8">
              {" "}
              Block Forever App{" "}
            </span>
          </div>
          <div className="caption mt-8">
            Your strongest ally against adult content.
          </div>
          <div className="caption mt-16">©️ 2024.</div>
        </div>

        <span className="flex-column">
          <span
            className="caption cursorPointer"
            onClick={() => navigate("/privacypolicy")}
          >
            Privacy Policy
          </span>
          <span
            className="mt-8 caption cursorPointer"
            onClick={() => navigate("/terms")}
          >
            Terms of Service
          </span>
        </span>
      </div>
    </div>
  );
}
